var _a;
import { optionsMap } from 'pro-gallery-lib';
export var OVERLAY = {
    OVERLAY_TYPE: 'controllers_behaviourParams_item_overlay_overlayType',
    SIZE_IN_PIXEL: "controllers_" + optionsMap.behaviourParams.item.overlay.size + "_pixel",
    SIZE_IN_PERCENT: "controllers_" + optionsMap.behaviourParams.item.overlay.size + "_percent",
};
export var OVERLAY_CONTROLLERS = (_a = {},
    _a[OVERLAY.OVERLAY_TYPE] = function (value) {
        var _a;
        if (value !== 'FULL') {
            return;
        }
        return _a = {},
            _a[optionsMap.behaviourParams.item.overlay.sizeUnits] = 'PERCENT',
            _a[optionsMap.behaviourParams.item.overlay.size] = 100,
            _a[optionsMap.behaviourParams.item.overlay.position] = 'BOTTOM',
            _a[optionsMap.behaviourParams.item.overlay.padding] = 0,
            _a;
    },
    _a[OVERLAY.SIZE_IN_PIXEL] = function (value, options) {
        var _a;
        var unitSize = options[optionsMap.behaviourParams.item.overlay.sizeUnits];
        var type = options[OVERLAY.OVERLAY_TYPE];
        if (unitSize !== 'PIXEL' || type !== 'PARTIAL' || value === undefined) {
            return;
        }
        return _a = {},
            _a[optionsMap.behaviourParams.item.overlay.size] = value,
            _a;
    },
    _a[OVERLAY.SIZE_IN_PERCENT] = function (value, options) {
        var _a;
        var unitSize = options[optionsMap.behaviourParams.item.overlay.sizeUnits];
        var type = options[OVERLAY.OVERLAY_TYPE];
        if (unitSize !== 'PERCENT' || type !== 'PARTIAL' || value === undefined) {
            return;
        }
        return _a = {}, _a[optionsMap.behaviourParams.item.overlay.size] = value, _a;
    },
    _a);
//# sourceMappingURL=overlay.js.map